module.exports = __webpack_public_path__ + "static/media/banner-robo-de-lances-comprasgov.d47f01f8.png";